import styled from 'styled-components';

import { RouterLink } from 'components/Link';
import { bodyMicroText, colors, transition } from 'theme/theme';

export const CartPillCountAndIconHolder = styled.div`
  display: flex;
  align-items: center;
`;

export const CartPillMenuItemEmptyMessage = styled.div`
  color: ${colors.lightContentGrey};
  padding: 5px 10px;
  ${bodyMicroText};
  border-bottom: 1px solid ${colors.calloutGrey};
`;

export const CartPillCount = styled.span`
  width: 12px;
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
`;

export const CartPillMenuItemLink = styled(RouterLink)<{
  $isSelected?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 10px;
  color: ${colors.lightContentGrey};
  transition: ${transition};
  font-size: 11px;
  user-select: none;

  background: ${(props) =>
    props.$isSelected ? colors.softBlue : 'transparent'};

  &:hover {
    color: ${colors.lightContentGrey};
    text-decoration: none;
    background: ${colors.calloutGrey};
  }
`;

export const CartPillMenuItemCount = styled.span`
  background: ${colors.brandBlue};
  transition: ${transition};
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
  font-size: 11px;
`;
